

import { RibCard } from "./RibCard";
import { DECK_GROUPS, type DeckCard, type DeckorateNav } from "./ribbonGroups";
import styles from "../DeckorateModule.module.css";

interface DeckorateHomeProps {
  readonly onNavigate: (view: DeckorateNav) => void;
  /** Opens the All-actions command palette (the "All actions" card's action). */
  readonly onOpenPalette: () => void;
}

function resolveCardClick(
  card: DeckCard,
  onNavigate: (view: DeckorateNav) => void,
  onOpenPalette: () => void,
): (() => void) | undefined {
  if (card.action === "open-palette") return onOpenPalette;
  if (card.nav) return () => onNavigate(card.nav as DeckorateNav);
  return undefined;
}

export function DeckorateHome({ onNavigate, onOpenPalette }: Readonly<DeckorateHomeProps>) {
  return (
    <div className={styles.home}>
      {DECK_GROUPS.map((group) => (
        <section key={group.title} className={styles.group}>
          <h3 className={styles.sectLabel}>
            {group.title}
            {group.subtitle && (
              <span className={styles.sectSub}>· {group.subtitle}</span>
            )}
          </h3>
          <div className={styles.grid}>
            {group.cards.map((card) => (
              <RibCard
                key={card.title}
                icon={card.icon}
                title={card.title}
                description={card.description}
                shortcut={card.shortcut}
                wide={card.wide}
                onClick={resolveCardClick(card, onNavigate, onOpenPalette)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
